import {Box, Card, CardContent, Divider, Typography} from "@mui/material";
import React from "react";

const TrendzContainerCard = (props) => {
    const {
        children,
        title,
        action,
        maxWidthPaper = 640,
        minWidthPaper,
        classRoot,
        ...remainProps
    } = props;

    return (
        <Card {...remainProps} className={`${classRoot}`}>
            {title &&
                <Box
                    sx={{display: "flex", flexDirection: "row", justifyContent: "space-between", margin: "14px 28px 15px 28px"}}>
                    <Typography
                        fontWeight="600"
                        variant="h5"
                        color="#1565c0"
                    >
                        {title}
                    </Typography>
                    <Box>
                        {action}
                    </Box>
                </Box>
            }

            <Divider/>
            <CardContent sx={{padding: title ? "8px 0 0 24px" : "0"}}>
                {children}
            </CardContent>

        </Card>
    );
};

export default React.memo(TrendzContainerCard);
